const SVGView = require('common/ui/view/svg/index');
const SVGUtil = require('common/ui/view/svg/util');

module.exports = SVGView.extend({
    tagName: 'foreignObject',

    /**
     * 背景を四角で縁取ったテキストです
     *
     * 実際には g タグが返ってくるので動かしたい場合は
     * transform を使って下さい。
     *
     * @constructs
     * @param params
     * @param params.offset {Object}
     * @param params.offset.x {Number} - x 方向のオフセット
     * @param params.offset.y {Number} - y 方向のオフセット
     * @param params.size {Number} - Text のサイズ
     * @param params.text {Strgin} - Text の文字列
     * @param params.bgcolor {Strgin} - 背景色
     * @param params.width {Number} - ボックスの大きさ(表示される文字列の長さが変わる)、デフォルト 256
     */
    initialize: function(params) {
        SVGView.prototype.initialize.call(this, params);
        this.params = params;
        this.offset = params.offset;
        this._bgcolor = params.bgcolor;
        this._size = params.size;
        this._text = params.text;
        this._width = params.width ? params.width : 256;
    },

    render: function() {
        const paddingTopBottom = this._size / 4;
        const paddingLeftRight = this._size / 2;
        const borderRadius = paddingTopBottom;
        const boxHeight = this._size + paddingTopBottom * 2;

        this.$el
            .attr('width', this._width)
            .attr('height', boxHeight)
            .attr(
                'transform',
                SVGUtil.transform({
                    x: this.offset.x,
                    y: this.offset.y
                })
            );

        this.$div = this.$el.append('xhtml:div')
            .style('width', this._width)
            .style('font-weight', 'bold')
            .style('height',`${boxHeight}px`)
            .style('color', 'white')
            .style('text-align', 'right')
            .style('font-size', `${this._size}px`)
            .style('line-height', `${this._size}px`)

        this.$div = this.$div.append('xhtml:span')
            .style('border-radius', `${borderRadius}px`)
            .style('padding', `${paddingTopBottom}px ${paddingLeftRight}px`)
            .style('background-color', this._bgcolor)
            .style('overflow', 'hidden')
            .style('display', 'inline-block')
            .style('max-width', '100%')
            .style('text-overflow', 'ellipsis')
            .style('white-space', 'nowrap')
            .html(this._text)

        return this;
    },

    text: function(text) {
        this.$text.html(text);
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/text/rect.js